import bus from '../bus'

const debug = true

export default ({ api, endpoint }) => {
  return {
    data () {
      return {
        loading: false
      }
    },
    methods: {
      async find (id, params = {}) {
        this.loading = true
        if (debug) console.log('[vue-repository] ' + endpoint + ' finding', id)
        try {
          return (await api.get(endpoint + '/' + id, params)).data
        } finally {
          this.loading = false
        }
      },
      async create (fields) {
        this.loading = true
        if (debug) console.log('[vue-repository] ' + endpoint + ' creating', fields)
        try {
          await api.post(endpoint, fields)
          bus.emit(endpoint + '.created')
        } finally {
          this.loading = false
        }
      },
      /*
       * Update a record, it allows two syntaxes:
       * - update(id, fields)
       * - update(fields) - in this case the id is taken from the fields
       */
      async update () {
        let fields = null
        let targets = null
        if (arguments.length === 1) {
          targets = arguments[0].id
          fields = { ...arguments[0], id: undefined }
        } else {
          targets = arguments[0]
          fields = arguments[1]
        }

        this.loading = true
        if (debug) console.log('[vue-repository] ' + endpoint + ' updating', targets, fields)
        try {
          if (targets.length > 1) {
            await api.put(endpoint, { entities: targets, ...fields })
          } else {
            await api.put(endpoint + '/' + targets, fields)
          }
          bus.emit(endpoint + '.updated')
        } finally {
          this.loading = false
        }
      },
      async remove (targets) {
        this.loading = true
        targets = Array.isArray(targets) ? targets : [targets]
        if (debug) console.log('[vue-repository] ' + endpoint + ' removing', targets)
        try {
          if (targets.length > 1) {
            await api.delete(endpoint, { entities: targets })
          } else {
            await api.delete(endpoint + '/' + targets[0])
          }
          bus.emit(endpoint + '.removed')
        } finally {
          this.loading = false
        }
      },
    }
  }
}